import { authorizeStartGuideContent } from "./authorize";
import { eprStartGuideContent } from "./epr";
import { invoiceStartGuideContent } from "./invoice";
import { taxStartGuideContent } from "./tax";
import { taxAgentStartGuideContent } from "./taxAgent";

const PROJECT_CONTENT = {
  LTax: taxStartGuideContent,
  LEPR: eprStartGuideContent,
  LInvoice: invoiceStartGuideContent,
  LAuthorize: authorizeStartGuideContent,
  LTax_agent: taxAgentStartGuideContent,
};

export const getStartGuideContent = (projectName) =>
  PROJECT_CONTENT[projectName] || taxStartGuideContent;

export {
  authorizeStartGuideContent,
  eprStartGuideContent,
  invoiceStartGuideContent,
  taxAgentStartGuideContent,
  taxStartGuideContent,
};
